import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { getError, getProject } from 'application/applicationReducer';
import SubmissionPanel from 'submission/components/SubmissionPanel';
import ErrorPanel from 'general-components/ErrorPanel';
import LoadingPanel from 'general-components/LoadingPanel';

const Application = ({ error, project }) =>
  R.isEmpty(error)
    ? R.isEmpty(project)
      ? <LoadingPanel message="Loading project..." />
      : <SubmissionPanel />
    : <ErrorPanel error={error} />;

const mapState = R.pipe(
  R.path(['application']),
  R.applySpec({
    error: getError,
    project: getProject,
  }),
);

export default connect(mapState)(Application);



// WEBPACK FOOTER //
// ./src/application/components/Application.js